export const BRAND_LIST_REQUEST = 'BRAND_LIST_REQUEST'
export const BRAND_LIST_SUCCESS = 'BRAND_LIST_SUCCESS'
export const BRAND_LIST_FAIL = 'BRAND_LIST_FAIL'
